import { IComponentBaseConfiguration } from '../models/IComponentBaseConfiguration.js';
import { IComponentBaseState } from '../models/IComponentBaseState.js';
import { ISvg, ISvgElement } from '../models/svg/index.js';

import { ComponentBase } from './ComponentBase.js';

export abstract class SvgElement<
	TProps extends ISvgElement,
	TState extends IComponentBaseState,
	TConfiguration extends IComponentBaseConfiguration,
> extends ComponentBase<TProps, TState, TConfiguration> {
	constructor(props: TProps) {
		super(props);
	}

	getBaseSvgProps(defaults?: Partial<ISvg>, overrides?: Partial<ISvg>): ISvg | undefined {
		const { baseSvgProps } = this.props;
		return {
			...defaults,
			...baseSvgProps,
			...overrides,
		};
	}

	getElementSvgProps<T>(
		defaults?: Partial<React.SVGProps<T>>,
		overrides?: Partial<React.SVGProps<T>>,
	): React.SVGProps<T> {
		const {
			theme,
			children,
			className,
			componentStyle,
			componentStyleProps,
			configuration,
			hide,
			baseSvgProps,
			analyticsContext,
			hideDisclaimers,
			suppressAnalytics,
			...svgProps
		} = this.props;

		return {
			...defaults,
			...svgProps,
			...overrides,
		};
	}

	getNumber(val: string | number): number {
		return typeof val === 'string' ? parseInt(val, 10) : val;
	}
}
